import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

var isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
dayjs.extend(isSameOrAfter);

var isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
dayjs.extend(isSameOrBefore);

var isoWeek = require("dayjs/plugin/isoWeek");
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Berlin");

export const startSeason = dayjs("2024-10-01").tz();
export const endSeason = dayjs("2024-11-30").tz();
export const DEFAULT_TIME_VALUE = "Wählen Sie einen Termin aus";
export const DEFAULT_SELECT_VALUE = "Wählen Sie eine Option aus";
export const SEASONAL_NO_CHECK = "no_check";
export const SEASONAL_WINTER_CHECK = "winter_check";
export const SEASONAL_EARLY_CHECK = "early_check";
export const HOLIDAY_VALUE = "holiday";
export const TIME_FORMAT = "HH:mm";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "DD.MM HH:mm";
export const weekDays = [
  "Montag",
  "Dienstag",
  "Mittwoch",
  "Donnerstag",
  "Freitag",
  "Samstag",
  "Sonntag",
];
export const BLOCKED_SLOT_LICENSEPLATE = "Vorführwagen";

export function disabledDate(date) {
  return (
    !dayjs(date).isSameOrAfter(startSeason) ||
    !dayjs(date).isSameOrBefore(endSeason) ||
    dayjs(date).isoWeekday() === 6 ||
    dayjs(date).isoWeekday() === 7
  );
}

export function checkBookingLists(current, time, slots) {
  const timeObj = dayjs(time, [TIME_FORMAT]);
  // const checkKey = current.hour(timeObj.hour()).minute(timeObj.minute());
  // const checkKeyFormated = checkKey.format(`${DATE_FORMAT}T${TIME_FORMAT}`);
  return slots.filter(
    (value) => dayjs(value.date).format(TIME_FORMAT) === timeObj
  );
}

export function getTimeSlotsForDate(locationTimeSlots, current) {
  const listData = locationTimeSlots.filter((slot) => {
    if (current.day() === (slot.week_day + 1) % 7 && !disabledDate(current)) {
      return slot;
    }
    return null;
  });
  return listData;
}

// IntlCode Input
export function count(max) {
  return {
    max,
    exceedFormatter: (value, config) => {
      return value.slice(0, config.max);
    },
  };
}

export function getHourAndMinute(dateString) {
  return dayjs(dateString).format("HH:mm");
}

export function getPhoneIntNumber(phone) {
  return phone.substr(1, 2);
}

export function getPhonePrefix(phone) {
  return phone.substr(4, 3);
}

export function getPhoneNumber(phone) {
  return phone.substr(8, 8);
}
